<template>
  <div id="login">
    <el-container class="page_login">
      <el-main>
        <!-- 登录卡片区域 -->
        <div class="checkFirstloginPage">
          <header class="title">首次登陆,请进行密保验证</header>
          <div class="el__steps">
            <el-form>
              <el-form-item>
                <div class="el__slot__label">
                  <span class="el__slot__label__span">问题1</span>
                  <el-select
                    class="el__label__select"
                    v-model="questionCode1"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in passQsList1"
                      :key="item.code"
                      :value="item.code"
                      :label="item.name"
                    >
                    </el-option>
                  </el-select>
                </div>
                <el-input v-model="answer1" placeholder="请输入答案"></el-input>
              </el-form-item>
              <el-form-item>
                <div class="el__slot__label">
                  <span class="el__slot__label__span">问题2</span>
                  <el-select
                    class="el__label__select"
                    v-model="questionCode2"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in passQsList2"
                      :key="item.code"
                      :value="item.code"
                      :label="item.name"
                    >
                    </el-option>
                  </el-select>
                </div>
                <el-input v-model="answer2" placeholder="请输入答案">
                </el-input>
              </el-form-item>

              <el-form-item class="el__form__item">
                <el-button
                  size="default"
                  type="primary"
                  class="el__button"
                  @click="questionSubmit"
                  >确定</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-main>
      <el-footer>
        <foo-ter></foo-ter>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import fooTer from '../footer/footer'
import { dictCode, setQuestions } from '@/api/home'
export default {
  components: {
    fooTer,
  },
  data() {
    return {
      passQsList: [],
      answer1: '',
      questionCode1: '',
      answer2: '',
      questionCode2: '',
    }
  },
  created() {
    this.dictCode()
  },
  computed: {
    passQsList1() {
      let arr = this.passQsList.filter((k) => k.code != this.questionCode2)
      return arr
    },
    passQsList2() {
      let arr = this.passQsList.filter((k) => k.code != this.questionCode1)
      return arr
    },
  },
  methods: {
    async dictCode() {
      const { data: res } = await dictCode({
        code: 'pwd_questions',
      })
      this.passQsList = res.data
    },
    questionSubmit() {
      if (
        this.answer1 === '' ||
        this.answer2 === '' ||
        this.questionCode1 === '' ||
        this.questionCode2 === ''
      ) {
        this.$message.error('问题不能为空,请填写完成')
        return false
      } else {
        let data = {
          roleType: localStorage.getItem('roleType'),
          userId: localStorage.getItem('userId'),
          useranswerList: [
            {
              answer: this.answer1,
              questionCode: this.questionCode1,
            },
            {
              answer: this.answer2,
              questionCode: this.questionCode2,
            },
          ],
        }
        setQuestions({ ...data }).then((res) => {
          setTimeout(() => {
            this.$router.replace('/bench')
          }, 500)
        })
      }
    },
  },
}
</script>
<style scoped>
#login {
  height: 969px;
  width: 100%;
}

.page_login {
  background-color: #f0f2f5;
  width: 100%;
  height: 100vh;
}

.el-main {
  background-image: url('../../assets/img/login/bg_image.a7a1ba61.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  page-break-after: auto;
  position: relative;
}
.checkFirstloginPage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  width: 1000px;
  padding: 50px 40px;
  height: 490px;
  border-radius: 10px;
}
.title {
  text-indent: 4%;
  font-size: 18px;
  color: #666;
  font-weight: 600;
}
.el__steps {
  width: 600px;
  margin: 40px auto;
}
.el-form {
  width: 100%;
}
.el__form__item {
  margin-top: 40px;
}
.el__button,
.el-select,
.el-input {
  width: 100%;
}
.el__slot__label {
  display: flex;
  justify-content: space-between;
}
.el__slot__label__span {
  display: block;
  padding: 0 2px;
  width: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/login/checkFirstlogin.vue